import LinkedLogo from '../public/images/icons/linkedin.svg';
import TwitterLogo from '../public/images/icons/twitter.svg';
import YoutubeLogo from '../public/images/icons/youtube.svg';

interface ISocialLink {
  href: string;
  // biome-ignore lint/suspicious/noExplicitAny: SVG icon component type varies by import
  icon?: any;
  ariaLabel?: string;
}

const SOCIAL_LINKS: ISocialLink[] = [
  {
    href: 'https://www.linkedin.com/company/parcel-monitor/?originalSubdomain=sg',
    icon: LinkedLogo,
    ariaLabel: 'Visit our LinkedIn page',
  },
  {
    href: 'https://www.youtube.com/channel/UCpNd8TRHhOkrRUPzW-bJMtA',
    icon: YoutubeLogo,
    ariaLabel: 'Visit our Youtube page',
  },
  {
    href: 'https://twitter.com/ParcelMonitor',
    icon: TwitterLogo,
    ariaLabel: 'Visit our Twitter page',
  },
];

export default SOCIAL_LINKS;
